import { render, staticRenderFns } from "./FreelancersMenu.vue?vue&type=template&id=19f104ee"
import script from "./FreelancersMenu.vue?vue&type=script&lang=js"
export * from "./FreelancersMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports